export default {
  branches: (state) => {
    return state.branches;
  },
  inActiveBranches: (state) => {
    return state.inActiveBranches;
  },
  branch: (state) => {
    return state.branch;
  },
  province: (state) => {
    return state.province;
  },
  provinceOptions: (state) => {
    const provinceOptions = [];
    state.province.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },
  cities: (state) => {
    return state.cities;
  },
  cityOptions: (state) => {
    const cityOptions = [];
    state.cities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityOptions.push(pushItem);
    }
    return cityOptions;
  },
};
